import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'sd-order-history-qr',
  templateUrl: './qr-code-modal.component.html',
  styleUrl: './qr-code-modal.component.scss',
  imports: [QRCodeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeModalComponent {
  orderCode = input.required<string>();
}
